import MainLayout from 'Components/Layout/MainLayout';
import {
    Button,
    Empty,
    Input,
    message,
    Pagination,
    Space,
    Spin,
    TreeSelect,
} from 'antd';
import React, {useState} from 'react';
import Style from './index.module.scss';
import {
    deleteArticle,
    exportArticle,
    GetArticle,
    getArticlePage,
} from './service';
import useRequestFn from '../../../Utils/Hooks/useRequestFn';
import {errorMessage} from '../../../Utils/common';
import {getTags} from '../WebTag/service';
import {useMutation, useQuery} from 'react-query';
import useModalHandler from '../../../Utils/Hooks/useModalHandler';
import EditTagModal from './Components/EditTagModal';
import usePagination from '../../../Utils/Hooks/usePagination';
import ProForm from 'Components/ProForm';
import ListItem from './Components/ListItem';
import {LinkButton} from '../../../Features/Buttons/LinkButton';
import DeleteConfirm from '../../../Components/DeleteConfirm';
import {isEmpty} from '../../../Stores/commonStore';
import {FormDataRangePicker} from '../../../Components/FormComponents/FormDataRangePicker';

export default function Index() {
    const [query, setQuery] = useState<GetArticle>({});
    const pagination = usePagination();
    const editTagModal = useModalHandler({component: EditTagModal});

    const onExport = useMutation({
        mutationFn: exportArticle,
        onSuccess: () => {
            message.success('导出成功!');
        },
    });

    const queryData = useQuery({
        queryKey: ['getArticlePage', query, pagination.params],
        queryFn: () => getArticlePage({...query, ...pagination.params}),
    });

    const toolBar = (
        <div className={Style.toolBar}>
            <Space>
                <Button
                    type="primary"
                    ghost
                    onClick={() => onExport.mutate(query)}
                    loading={onExport.isLoading}>
                    Excel导出
                </Button>
            </Space>
        </div>
    );

    const treeOptions = useQuery({
        queryKey: ['getTags'],
        queryFn: () => getTags(),
    });

    const [deleteAction] = useRequestFn(deleteArticle);

    async function onDelete(id: string) {
        try {
            await deleteAction(id);
            await queryData?.refetch();
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    return (
        <MainLayout.SpaceWrapper padding>
            <ProForm.Query onFinish={setQuery}>
                <ProForm.Field label="开始日期" name="time">
                    <FormDataRangePicker />
                </ProForm.Field>
                <ProForm.Field label="关键字" name="keyword">
                    <Input placeholder="请输入关键字" />
                </ProForm.Field>
                <ProForm.Field label="标签" name="tagIds">
                    <TreeSelect
                        allowClear
                        treeData={treeOptions?.data}
                        treeCheckable
                    />
                </ProForm.Field>
            </ProForm.Query>

            <div className={Style.content}>
                {toolBar}
                {isEmpty(queryData?.data?.data) && (
                    <Empty style={{margin: 50}} />
                )}
                <Spin spinning={queryData.isFetching}>
                    {queryData?.data?.data?.map(item => (
                        <ListItem
                            key={item.id}
                            data={item}
                            action={
                                <Space size={15}>
                                    <LinkButton
                                        key="tag"
                                        onClick={() =>
                                            editTagModal.open({
                                                onOk: () => {
                                                    editTagModal.close();
                                                    queryData?.refetch();
                                                },
                                                data: item,
                                            })
                                        }>
                                        修改标签
                                    </LinkButton>
                                    <DeleteConfirm
                                        key="del"
                                        onSuccess={() => onDelete(item.id)}>
                                        <LinkButton>删除</LinkButton>
                                    </DeleteConfirm>
                                </Space>
                            }
                        />
                    ))}
                    <div className={Style.page}>
                        <Pagination
                            current={pagination.params.pageNo}
                            pageSize={pagination.params.pageSize}
                            onChange={page => {
                                pagination.gotoPage(page);
                            }}
                            total={queryData?.data?.total}
                        />
                    </div>
                </Spin>
            </div>
            {editTagModal.render()}
        </MainLayout.SpaceWrapper>
    );
}
